import React, { useState } from "react";
import { Box, ColorInput, ColorPicker, Flex, Group, Text } from "@mantine/core";

import classes from './AIColorInput.module.css'

export const AIColorInput = ({ defaultValue, onChange, aiSuggestions, ...props }) => {

    const [selectedColor, setSelectedColor] = useState(defaultValue || '#FFF');

    const handleColorChange = (color) => {
        setSelectedColor(color);
        onChange && onChange(color);
    };

    return (
        <Box>
            <ColorInput
                value={selectedColor}
                onChange={handleColorChange}
                variant="filled"
                radius="md"
                {...props}
            />
            {aiSuggestions?.colors?.length > 0 &&
                <Flex mt={4} gap={4} align="center" wrap="nowrap">
                    <Text fw={500} fz={14} c="gray">
                        AI Suggestions
                    </Text>
                    <ColorPicker
                        styles={{ swatch: { borderRadius: 15 } }}
                        withPicker={false}
                        swatches={aiSuggestions?.colors || []}
                        swatchesPerRow={11}
                        value={selectedColor}
                        onChange={handleColorChange}
                        classNames={classes}
                    />
                </Flex>
            }
        </Box>
    );
};
